import classNames from "classnames";
import PropTypes from "prop-types";
import { Button as MuiButton } from "@mui/material";
import styles from "./miniButton.styles.module.scss";

const variantMiniButtonType = {
  darkTheme: "darkTheme",
  destructive: "destructive",
  default: "",
  darkThemeDestructive: "darkThemeDestructive",
};

const propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  isSvgAffected: PropTypes.bool,
  onClick: PropTypes.func,
  rootClassName: PropTypes.string,
  variant: PropTypes.string,
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const MiniButton = ({
  ariaLabel = "",
  children,
  disabled = false,
  isSvgAffected = true,
  onClick = () => { },
  rootClassName = "",
  variant = "",
  ...otherProps
}) => {
  return (
    <MuiButton
      {...otherProps}
      aria-label={ariaLabel || null}
      className={classNames(
        rootClassName,
        styles.root,
        "mini-btn",
        variant === variantMiniButtonType.darkTheme && "dark-theme-mini-btn",
        variant === variantMiniButtonType.destructive && "destructive-mini-btn",
        variant === variantMiniButtonType.darkThemeDestructive && "dark-destructive-mini-btn",
        "mini-btn-rounded",
        isSvgAffected && styles.svgEffect
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </MuiButton>
  );
};

MiniButton.propTypes = propTypes;
export { MiniButton, variantMiniButtonType };
